import React from "react";
import Signup from "@/components/Pages/Auth/Signup";
const SignupPage: React.FC = () => {
  return <Signup />;
};

export default SignupPage;
